/* tslint:disable */
/* eslint-disable */
/**
 * Product Page Aggregator
 * Aggregator for the product page on web and native apps
 *
 * The version of the OpenAPI document: 1
 * Contact: mark.salt@autotrader.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CTAKeyEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY'
};
/**
 * Check if a given object implements the CTA interface.
 */
export function instanceOfCTA(value) {
    if (!('key' in value) || value['key'] === undefined)
        return false;
    if (!('text' in value) || value['text'] === undefined)
        return false;
    return true;
}
export function CTAFromJSON(json) {
    return CTAFromJSONTyped(json, false);
}
export function CTAFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'key': json['key'],
        'text': json['text'],
    };
}
export function CTAToJSON(json) {
    return CTAToJSONTyped(json, false);
}
export function CTAToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'key': value['key'],
        'text': value['text'],
    };
}
